import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import { VoiceDiscoveryLobby } from "@/components/voice-discovery/VoiceDiscoveryLobby";
import { VoiceDiscoveryRoom } from "@/components/voice-discovery/VoiceDiscoveryRoom";
import BottomNav from "@/components/BottomNav";

const VoiceDiscovery = () => {
  const [activeRoomId, setActiveRoomId] = useState<string | null>(null);

  return (
    <div className="min-h-screen bg-background pb-20">
      <AnimatePresence mode="wait">
        {activeRoomId ? (
          <VoiceDiscoveryRoom
            key="room"
            roomId={activeRoomId}
            onLeave={() => setActiveRoomId(null)}
          />
        ) : (
          <VoiceDiscoveryLobby
            key="lobby"
            onJoinRoom={(roomId) => setActiveRoomId(roomId)}
          />
        )}
      </AnimatePresence>
      
      {!activeRoomId && <BottomNav />}
    </div>
  );
};

export default VoiceDiscovery;
